module.exports = __webpack_public_path__ + "img/1-.f7334f97.png";